export const initWakeLockService = async () => {
  let wakeLock = undefined;
  window.addEventListener('game_window', async (event) => {
    const state = event.detail.state;
    if (state) {
      try {
        wakeLock = await navigator.wakeLock.request('screen');
      } catch (err) {
        console.log(`${err.name}, ${err.message}`);
      }
      return;
    }
    if (typeof wakeLock?.release == 'function') {
      wakeLock.release();
      wakeLock = undefined;
    }
  });
};
